import { createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'

import { MediaSummaryDetails } from '@/learnpaths-media/components/MediaSummaryDetails/MediaSummaryDetails'
import { CONTENT_LOCALE } from '@/locale/constants'

const searchSchema = v.object({
  lang_edit: v.optional(v.picklist(CONTENT_LOCALE)),
})

export const Route = createFileRoute(
  '/company/_management/courses/overview/$mediaId/$tab',
)({
  validateSearch: searchSchema,
  component: MediaSummaryDetails,
})
